__turbopack_context__.v({
  "className": "inter_5b88c73-module__iX8OrW__className",
});
